import { http } from '@pendo/http';
import { EMPTY_VALUE } from './emails.module';

export function loadEmails () {
    return http.get('/api/s/_SID_/omnichannel');
}

export function loadEmailIdentities (appId) {
    return http.get(`/api/s/_SID_/email/identity${appId ? `?appId=${appId}` : ''}`);
}

export function loadOrganizationEmailIdentities (orgId) {
    return http.get(`/api/organization/${orgId}/email/identity`);
}

export function loadEmailIdentity (identity) {
    return http.get(`/api/s/_SID_/email/identity/${identity}`);
}

export function loadOrganizationEmailIdentity (orgId, identity) {
    return http.get(`/api/organization/${orgId}/email/identity/${identity}`);
}

export function deleteEmailDomain (identity) {
    return http.delete(`/api/s/_SID_/email/identity/${identity}`);
}

export function updateEmailField (omniChannelId, channelType, field, value) {
    return http.put(`/api/s/_SID_/omnichannel/${omniChannelId}/${channelType}/${field}`, { [field]: value });
}

export function updateEmailFieldObj (omniChannelId, channelType, field, value) {
    return http.put(`/api/s/_SID_/omnichannel/${omniChannelId}/${channelType}/${field}`, value);
}

export function updateOmniChannelField (omniChannelId, field, value) {
    let payload = {};

    if (typeof value !== 'object') {
        payload = { [field]: value };
    } else {
        payload = value;
    }

    return http.put(`/api/s/_SID_/omnichannel/${omniChannelId}/${field}`, payload);
}

export function loadEmail (omniChannelId) {
    return http.get(`/api/s/_SID_/omnichannel/${omniChannelId}`);
}

export function deleteOmniChannelById (omniChannelId) {
    return http.delete(`/api/s/_SID_/omnichannel/${omniChannelId}`);
}

export function createOmnichannel (payload) {
    return http.post('/api/s/_SID_/omnichannel', payload);
}

export function loadEmailProviders () {
    return http.get('/api/s/_SID_/omnichannel/providers');
}

export function loadEmailsByProvider (provider) {
    return http.get(`/api/s/_SID_/omnichannel/providers/${provider}/email`);
}

export function cloneOmnichannel (omnichannelId) {
    return http.post(`/api/s/_SID_/omnichannel/${omnichannelId}/clone`);
}

export function createEmailDomain (domain) {
    const payload = {
        type: 'DOMAIN',
        identity: domain,
    };

    return http.post('/api/s/_SID_/email/identity', payload);
}

export function updateEmailMailFromDomain (identity, domain) {
    return http.put(`/api/s/_SID_/email/identity/${identity}/mailfrom`, { domain });
}

export function getEmailProfilesForKind (kind) {
    return http
        .get(`/api/s/_SID_/emailprofile/${kind}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function saveEmailProfile ({
    friendlyFromName,
    identity,
    from,
    replyTo,
    recipientMetadataPropertyName,
    type,
    isDefault,
    kind,
}) {
    return http
        .post(
            '/api/s/_SID_/emailprofile',
            {
                friendlyFromName,
                identity,
                from,
                replyTo,
                recipientMetadataPropertyName,
                type,
                default: isDefault,
                kind,
            },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function replaceDefaultSubject (email) {
    if (!email) return;
    const { subject, ...properties } = email;

    return {
        ...properties,
        subject: subject === EMPTY_VALUE ? undefined : subject,
    };
}

export function generateVocUpdateEmailCampaign ({
    vocItemId,
    emailProfileId,
    subject,
    steps,
    sendEmail,
    appId,
    pinpointCampaignId = null,
    vocEmailUpdateId = null,
    autoSendToNewSubscribers = false,
}) {
    return http
        .post(
            `/api/s/_SID_/vocItem/${vocItemId}/vocItemUpdate/campaign`,
            {
                ...(sendEmail
                    ? {
                        pinpointCampaignStatus: 'public',
                    }
                    : {}),
                ...(pinpointCampaignId && { pinpointCampaignId }),
                ...(vocEmailUpdateId && { vocEmailUpdateId }),
                emailProfileId,
                subject,
                appId,
                steps,
                autoSendToNewSubscribers,
            },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function sendTestEmail ({ emailId, recipients, emailSettings, templates }) {
    return http
        .post(
            `/api/s/_SID_/omnichannel/${emailId}/email/sendtestmessage`,
            {
                email: {
                    recipients,
                    emailSettings,
                    ...(templates && { templates }),
                },
            },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}
